var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      attrs: {
        editTitle: "Fährpreis" + _vm.title + "bearbeiten",
        createTitle: "Neuen Fährpreis" + _vm.title + "hinzufügen",
      },
    },
    [
      _c(
        "table",
        [
          _vm.initialValue
            ? [
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [_vm._v("Preis:")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c(
                        "toggle-switch",
                        {
                          model: {
                            value: _vm.priceType,
                            callback: function ($$v) {
                              _vm.priceType = $$v
                            },
                            expression: "priceType",
                          },
                        },
                        [
                          _c("option", { attrs: { value: "calculation" } }, [
                            _vm._v("Kalkulation"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "provider" } }, [
                            _vm._v("Anbieter"),
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "agency" } }, [
                            _vm._v("Agentur"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.priceType === "agency"
                  ? _c("tr", [
                      _c("th", [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Agentur:"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("async-select", {
                            attrs: { api: "agencies" },
                            model: {
                              value: _vm.agency,
                              callback: function ($$v) {
                                _vm.agency = $$v
                              },
                              expression: "agency",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.priceType === "provider" || _vm.priceType === "agency"
                  ? _c("tr", [
                      _c("th", [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Fährgesellschaft:"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("async-select", {
                            attrs: { api: "ferries" },
                            model: {
                              value: _vm.ferry,
                              callback: function ($$v) {
                                _vm.ferry = $$v
                              },
                              expression: "ferry",
                            },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _c("label", { staticClass: "label" }, [_vm._v("Bezeichnung:")]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c(
                  "toggle-switch",
                  {
                    model: {
                      value: _vm.ownName,
                      callback: function ($$v) {
                        _vm.ownName = $$v
                      },
                      expression: "ownName",
                    },
                  },
                  [
                    _c("option", { domProps: { value: true } }, [
                      _vm._v("Individuell"),
                    ]),
                    _vm._v(" "),
                    _c("option", { domProps: { value: false } }, [
                      _vm._v("Automatisch (nach Datum)"),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.ownName
            ? _c("tr", [
                _c("th", [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Eigene Bezeichnung:"),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.name,
                          expression: "form.name",
                        },
                      ],
                      staticClass: "input",
                      attrs: { type: "text", id: "name" },
                      domProps: { value: _vm.form.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "name", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("tr", [
            _c("th", { staticClass: "is-top" }, [
              _c("label", { staticClass: "label" }, [
                _vm._v("\n                    Zeitraum:\n                    "),
                _vm.canAddPeriod
                  ? _c(
                      "i",
                      {
                        staticClass: "material-icons is-pointer",
                        on: { click: _vm.addPeriod },
                      },
                      [_vm._v("add_circle")]
                    )
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              _vm._l(_vm.timePeriods, function (period) {
                return _c(
                  "div",
                  { key: period.key, staticClass: "level-left" },
                  [
                    _c(
                      "div",
                      { staticClass: "flatpickr-combined level-item" },
                      [
                        _c("input-date", {
                          staticClass: "is-small",
                          model: {
                            value: period.startAt,
                            callback: function ($$v) {
                              _vm.$set(period, "startAt", $$v)
                            },
                            expression: "period.startAt",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("-")]),
                        _vm._v(" "),
                        _c("input-date", {
                          staticClass: "is-small",
                          model: {
                            value: period.endAt,
                            callback: function ($$v) {
                              _vm.$set(period, "endAt", $$v)
                            },
                            expression: "period.endAt",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "level-item" },
                      [
                        _c("days", {
                          attrs: { picker: "" },
                          model: {
                            value: period.days,
                            callback: function ($$v) {
                              _vm.$set(period, "days", $$v)
                            },
                            expression: "period.days",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.timePeriods.length > 1
                      ? _c(
                          "i",
                          {
                            staticClass: "material-icons is-pointer",
                            on: {
                              click: function ($event) {
                                return _vm.deletePeriod(period)
                              },
                            },
                          },
                          [_vm._v("delete")]
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("service-day-time-field", {
            attrs: {
              label: "Gültig für",
              fields: ["startTimeOfDay", "endTimeOfDay", "checkInTimeOfDay"],
              "predefined-day-times": _vm.predefinedDayTimes,
            },
            model: {
              value: _vm.form.serviceDayTimes,
              callback: function ($$v) {
                _vm.$set(_vm.form, "serviceDayTimes", $$v)
              },
              expression: "form.serviceDayTimes",
            },
          }),
          _vm._v(" "),
          _c("tr", [
            _c("td", { attrs: { colspan: "2" } }, [
              _c("h2", [_vm._v("Preise")]),
            ]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _c("label", { staticClass: "label" }, [_vm._v("Überprüft:")]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("import-checked-field", {
                  model: {
                    value: _vm.importChecked,
                    callback: function ($$v) {
                      _vm.importChecked = $$v
                    },
                    expression: "importChecked",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _c("label", { staticClass: "label" }, [_vm._v("Währung:")]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("multiselect", {
                  staticStyle: { width: "70px" },
                  attrs: {
                    options: _vm.currencies,
                    "allow-empty": false,
                    placeholder: "",
                  },
                  model: {
                    value: _vm.currency,
                    callback: function ($$v) {
                      _vm.currency = $$v
                    },
                    expression: "currency",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.form.route && _vm.form.route.type === "night"
            ? [
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getAccommodationLabel(
                            "inside",
                            2,
                            _vm.allCabinTypes
                          )
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("input-price", {
                        staticClass: "is-medium",
                        attrs: { placeholder: "0,00", prefix: _vm.currency },
                        model: {
                          value: _vm.doubleInsidePrice,
                          callback: function ($$v) {
                            _vm.doubleInsidePrice = $$v
                          },
                          expression: "doubleInsidePrice",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getAccommodationLabel(
                            "inside",
                            1,
                            _vm.allCabinTypes
                          )
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("input-price", {
                        staticClass: "is-medium",
                        attrs: { placeholder: "0,00", prefix: _vm.currency },
                        model: {
                          value: _vm.singleInsidePrice,
                          callback: function ($$v) {
                            _vm.singleInsidePrice = $$v
                          },
                          expression: "singleInsidePrice",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm
                            .getAccommodationLabel(
                              "outside",
                              2,
                              _vm.allCabinTypes
                            )
                            .replace(
                              "Doppelkabine - Außenkabinenzuschlag",
                              "DK - Außenkabinenzuschlag"
                            )
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("input-price", {
                        staticClass: "is-medium",
                        attrs: { placeholder: "0,00", prefix: _vm.currency },
                        model: {
                          value: _vm.doubleOutsidePrice,
                          callback: function ($$v) {
                            _vm.doubleOutsidePrice = $$v
                          },
                          expression: "doubleOutsidePrice",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm
                            .getAccommodationLabel(
                              "outside",
                              1,
                              _vm.allCabinTypes
                            )
                            .replace(
                              "Einzelkabine - Außenkabinenzuschlag",
                              "EK - Außenkabinenzuschlag"
                            )
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("input-price", {
                        staticClass: "is-medium",
                        attrs: { placeholder: "0,00", prefix: _vm.currency },
                        model: {
                          value: _vm.singleOutsidePrice,
                          callback: function ($$v) {
                            _vm.singleOutsidePrice = $$v
                          },
                          expression: "singleOutsidePrice",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("tr", [
            _c("th", [
              _c("label", { staticClass: "label" }, [
                _vm._v("Überfahrt pro Person:"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("input-price", {
                  staticClass: "is-medium",
                  attrs: { placeholder: "0,00", prefix: _vm.currency },
                  model: {
                    value: _vm.ticketPrice,
                    callback: function ($$v) {
                      _vm.ticketPrice = $$v
                    },
                    expression: "ticketPrice",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", [_c("label", { staticClass: "label" }, [_vm._v("Bus:")])]),
            _vm._v(" "),
            _c(
              "td",
              [
                _c("input-price", {
                  staticClass: "is-medium",
                  attrs: { placeholder: "0,00", prefix: _vm.currency },
                  model: {
                    value: _vm.busPrice,
                    callback: function ($$v) {
                      _vm.busPrice = $$v
                    },
                    expression: "busPrice",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.taxes
            ? [
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Steuern - Bus:"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("input-price", {
                        staticClass: "is-medium",
                        attrs: { placeholder: "0,00", prefix: _vm.currency },
                        model: {
                          value: _vm.busTaxPrice,
                          callback: function ($$v) {
                            _vm.busTaxPrice = $$v
                          },
                          expression: "busTaxPrice",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Steuern pro Peron:"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "level-left" }, [
                      _c(
                        "div",
                        { staticClass: "level-item" },
                        [
                          _c("input-price", {
                            staticClass: "is-medium",
                            attrs: {
                              placeholder: "0,00",
                              prefix: _vm.currency,
                            },
                            model: {
                              value: _vm.ticketTaxPrice,
                              callback: function ($$v) {
                                _vm.ticketTaxPrice = $$v
                              },
                              expression: "ticketTaxPrice",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          on: {
                            click: function ($event) {
                              _vm.taxes = false
                            },
                          },
                        },
                        [_vm._v("delete")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.threeBedCabins
            ? [
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getAccommodationLabel(
                            "inside",
                            3,
                            _vm.allCabinTypes
                          )
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "level-left" }, [
                      _c(
                        "div",
                        { staticClass: "level-item" },
                        [
                          _c("input-price", {
                            staticClass: "is-medium",
                            attrs: {
                              placeholder: "0,00",
                              prefix: _vm.currency,
                            },
                            model: {
                              value: _vm.tripleInsidePrice,
                              callback: function ($$v) {
                                _vm.tripleInsidePrice = $$v
                              },
                              expression: "tripleInsidePrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm
                            .getAccommodationLabel(
                              "outside",
                              3,
                              _vm.allCabinTypes
                            )
                            .replace(
                              "Dreibettkabine - Außenkabinenzuschag",
                              "3-K - Außenkabinenzuschlag"
                            )
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "level-left" }, [
                      _c(
                        "div",
                        { staticClass: "level-item" },
                        [
                          _c("input-price", {
                            staticClass: "is-medium",
                            attrs: {
                              placeholder: "0,00",
                              prefix: _vm.currency,
                            },
                            model: {
                              value: _vm.tripleOutsidePrice,
                              callback: function ($$v) {
                                _vm.tripleOutsidePrice = $$v
                              },
                              expression: "tripleOutsidePrice",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          on: {
                            click: function ($event) {
                              _vm.threeBedCabins = false
                            },
                          },
                        },
                        [_vm._v("delete")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.fourBedCabins
            ? [
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.getAccommodationLabel(
                            "inside",
                            4,
                            _vm.allCabinTypes
                          )
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "level-left" }, [
                      _c(
                        "div",
                        { staticClass: "level-item" },
                        [
                          _c("input-price", {
                            staticClass: "is-medium",
                            attrs: {
                              placeholder: "0,00",
                              prefix: _vm.currency,
                            },
                            model: {
                              value: _vm.quadrupleInsidePrice,
                              callback: function ($$v) {
                                _vm.quadrupleInsidePrice = $$v
                              },
                              expression: "quadrupleInsidePrice",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _c("label", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(
                          _vm
                            .getAccommodationLabel(
                              "outside",
                              4,
                              _vm.allCabinTypes
                            )
                            .replace(
                              "Vierbettkabine - Außenkabinenzuschag",
                              "4-K - Außenkabinenzuschlag"
                            )
                        ) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticClass: "level-left" }, [
                      _c(
                        "div",
                        { staticClass: "level-item" },
                        [
                          _c("input-price", {
                            staticClass: "is-medium",
                            attrs: {
                              placeholder: "0,00",
                              prefix: _vm.currency,
                            },
                            model: {
                              value: _vm.quadrupleOutsidePrice,
                              callback: function ($$v) {
                                _vm.quadrupleOutsidePrice = $$v
                              },
                              expression: "quadrupleOutsidePrice",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "i",
                        {
                          staticClass: "material-icons",
                          on: {
                            click: function ($event) {
                              _vm.fourBedCabins = false
                            },
                          },
                        },
                        [_vm._v("delete")]
                      ),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          !_vm.taxes
            ? _c("tr", [
                _c("th"),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          _vm.taxes = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add_circle"),
                      ]),
                      _vm._v(" Steuern\n                "),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.threeBedCabins &&
          _vm.form.route &&
          _vm.form.route.type === "night"
            ? _c("tr", [
                _c("th"),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          _vm.threeBedCabins = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add_circle"),
                      ]),
                      _vm._v(" 3-Bettkabinen\n                "),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.fourBedCabins &&
          _vm.form.route &&
          _vm.form.route.type === "night"
            ? _c("tr", [
                _c("th"),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function ($event) {
                          _vm.fourBedCabins = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add_circle"),
                      ]),
                      _vm._v(" 4-Bettkabinen\n                "),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.existingPrices.length > 0
            ? _c("tr", [
                _c("td", { staticClass: "alert is-danger" }),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "alert is-danger" }, [
                    _c("p", [_c("strong", [_vm._v("Preise überschreiben?")])]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n                        Im angegebenen Preise existieren bereits folgende Preise, die beim erneuten Klick auf Speichern überschrieben werden:\n                    "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.existingPrices, function (price) {
                        return _c("li", [
                          _vm._v(
                            _vm._s(
                              price.timePeriods
                                .map(
                                  (item) => item.startAt + " - " + item.endAt
                                )
                                .join(" | ")
                            ) +
                              " - EK in der DK: " +
                              _vm._s(
                                price.providerPrices
                                  .filter(
                                    (item) =>
                                      item.cabinType &&
                                      item.cabinType.cabinIndex === "2_inside"
                                  )
                                  .map((item) => item.price.formatted)
                                  .join(" | ")
                              )
                          ),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }